<ds-card class="flex-column p-4">
  <ng-container #fieldComponent />
</ds-card>
